import { Button, Card, Checkbox, Grid, IconButton, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../../../../core/redux/store';
import { TReport } from '../../../../reports/definitions';
import { updateUserReportsAction } from '../../redux/actions/user-actions';
import { reportPermissionsStyles } from './styles';

export default function ReportsPermissionsComponent({ user }) {
  const dispatch = useDispatch();
  const classes = reportPermissionsStyles();

  const state = store.getState();
  const token = state.token.token;

  const { reports } = useSelector((state) => state.reports);

  // these are teh reports attached tot eh user at time of loading page
  const [userReports, setUserReports] = useState<string[]>([]);
  // These are the above reports in addition to whats been changed
  // the above will be used to reset the UI when the user clicks cancel
  const [selectedReports, setSelectedReports] = useState<string[]>([]);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!user.permissions.reports) return;

    const userReports = user.permissions.reports.map((report: TReport) => report.id);

    setUserReports(userReports);
    setSelectedReports(userReports);
  }, [user, reports]);

  const updateSelectedReports = (reportId: string) => {
    const exists = selectedReports.includes(reportId);

    if (exists) {
      setSelectedReports(selectedReports.filter((id) => id !== reportId));
    } else {
      setSelectedReports([...selectedReports, reportId]);
    }
  };

  const onCancel = () => {
    setSelectedReports(userReports);
    setIsEditing(false);
  };

  const onSave = () => {
    const reportsToUpdate = reports.filter((r: TReport) => selectedReports.includes(r.id));
    dispatch(updateUserReportsAction(token, user.permissions.permissions_id, reportsToUpdate));
    setIsEditing(false);
  };

  return (
    <Card className={classes.card}>
      <Grid container justify="space-between">
        <Grid item>
          <Typography variant="h6">Reports and Permissions</Typography>
        </Grid>
        <Grid item>
          {!isEditing && (
            <IconButton onClick={() => setIsEditing(true)}>
              <EditIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <Grid container>
        {reports.map((report: TReport) => {
          return (
            <Grid
              container
              alignItems="center"
              xs={12}
              direction="row"
              key={report.id}
              spacing={2}
              className={classes.userRow}
              onClick={() => updateSelectedReports(report.id)}
            >
              <Grid item>
                <Checkbox
                  checked={selectedReports.includes(report.id)}
                  disabled={!isEditing}
                  onChange={() => updateSelectedReports(report.id)}
                />
              </Grid>
              <Grid item xs>
                <Typography>{report.name}</Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid container justify="space-between">
        {isEditing && (
          <>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<CloseIcon />}
                onClick={() => onCancel()}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CheckIcon />}
                onClick={() => onSave()}
                style={{ marginLeft: 10 }}
              >
                Save Changes
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );
}
